import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as mediaActions from '../store/media/actions';
import * as listsActions from '../store/lists/actions';
import * as adsActions from '../store/ads/actions';
import * as reducers from '../store/reducers';
// import * as settings from 'Settings';

import ContentCanvas from 'Components/ContentCanvas';
import ContentHeader from 'Components/ContentHeader';
import ContentInfoBox from 'Components/ContentInfoBox';
import GameControls from 'Components/GameControls';
import Loading from 'Components/Loading';
// import ContentTags from 'Components/ContentTags';
// import ErrorPage from 'Screens/ErrorPage';
// import Loading from 'Components/Loading';
import StaticAdSlot from 'Components/AdSlot/StaticAdSlot';
import DocumentHeadFields from 'Components/DocumentHeadFields';
import PromoBox from 'Components/PromoBox';
import MammalsMaterials from 'Components/Promos/TinybopSchoolsMaterials/MammalsMaterials';
import SpaceMaterials from 'Components/Promos/TinybopSchoolsMaterials/SpaceMaterials';
import CoralReefMaterials from 'Components/Promos/TinybopSchoolsMaterials/CoralReefMaterials';
import HumanBodyMaterials from 'Components/Promos/TinybopSchoolsMaterials/HumanBodyMaterials';
import SimpleMachinesMaterials from 'Components/Promos/TinybopSchoolsMaterials/SimpleMachinesMaterials';
import EarthMaterials from 'Components/Promos/TinybopSchoolsMaterials/EarthMaterials';
import HomesMaterials from 'Components/Promos/TinybopSchoolsMaterials/HomesMaterials';
import SkyscrapersMaterials from 'Components/Promos/TinybopSchoolsMaterials/SkyscrapersMaterials';
import WeatherMaterials from '../components/Promos/TinybopSchoolsMaterials/WeatherMaterials';
import Button from 'Components/Button';
import { TINYBOP_EMBEDDED_GAMES } from 'Constants/tinybopEmbeddedGames';
import * as api from '../api';

class SchoolsDemoPage extends Component {
  constructor(props) {
    super(props);
    this.startGameHandler = this.startGameHandler.bind(this);
    this.state = {
      pageLoading: false,
      modelSlug: '',
    };
  }

  componentDidMount() {
    api.fetchTinybopEmbeddedGame().then(gameData => {
      if (gameData && gameData.slug) {
        const { slug } = gameData;
        const shortenedSlug = slug.split('tinybop-schools-')[1];
        // console.log('GOT SLUG', shortenedSlug);
        this.setState({ modelSlug: shortenedSlug });
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.slug !== prevProps.slug) {
      this.setState({ pageLoading: true });
    }
    if (this.props.game !== prevProps.game) {
      this.setState({ pageLoading: false });
    }
    if (!this.props.isFetching && this.state.pageLoading) {
      this.setState({ pageLoading: false });
    }
  }

  startGameHandler(slug) {
    this.props.onStartGame(slug);
  }

  render() {
    const {
      lists,
      isFetching,
      isListsFetching,
      errors,
      onStartGame,
      onEndGame,
      onReplayGame,
      onGameRestart,
    } = this.props;

    const { modelSlug } = this.state;

    if (!modelSlug) return <Loading />;

    const { pageLoading } = this.state;

    const outboundLink =
      'https://schools.tinybop.com/?utm_source=funbrain&utm_campaign=201812_promo';

    /* NOTE: Change this to change which Tinybop Game is currently selected */
    const gameData = TINYBOP_EMBEDDED_GAMES[modelSlug];

    const gameMaterialsComponentMap = {
      'coral-reef': CoralReefMaterials,
      mammals: MammalsMaterials,
      space: SpaceMaterials,
      'human-body': HumanBodyMaterials,
      'simple-machines': SimpleMachinesMaterials,
      earth: EarthMaterials,
      homes: HomesMaterials,
      skyscrapers: SkyscrapersMaterials,
      weather: WeatherMaterials
    };

    const MaterialsComponent = gameMaterialsComponentMap[gameData.slug];

    return (
      <main>
        {gameData ? <DocumentHeadFields mediaItem={gameData} /> : null}
        <div className="Page__container Page__container--no-padding">
          <StaticAdSlot
            src="https://www.funbrain.com/assets/img/sponsors/custom/TinybopSchools201809/TinybopSchools201809_banner_728x90.png"
            link={`${outboundLink}&utm_medium=banner&utm_content=leaderboard`}
          />
        </div>
        <div className="Page__ContentWrapper" style={{ maxWidth: '90em' }}>
          <div className="Page__container Page__container--split-layout Page__container--main">
            <section className="ContentBlock ContentBlock--schools-promo ContentBlock--content-canvas">
              <div
                className="ContentBlock__content--full"
                style={{ maxWidth: 962 }}
              >
                <ContentHeader
                  {...gameData}
                  hideSquare
                  sponsoredBy={(
                    <a
                      className="ContentHeader__sponsored-by"
                      href={`${outboundLink}&utm_medium=text&utm_content=sponsoredby`}
                      target="_blank"
                    >
                      Brought to you by
                      <img
                        src="https://www.funbrain.com/assets/img/sponsors/custom/TinybopSchools201809/TinybopSchools201809_logo.png"
                        alt="Tinybop Schools"
                        style={{
                          maxWidth: '5rem',
                          display: 'inline-block',
                          margin: '0 0 0 1em',
                        }}
                      />
                    </a>
    )}
                />
                <ContentCanvas
                  {...gameData}
                  gameStarted={true}
                  type="tinybop-schools"
                  onStartGame={() => this.startGameHandler(gameData.slug)}
                  showPreContentAd={false}
                />
              </div>
              <div className="ContentBlock__content">
                <div className="Page__item-details">
                  <ContentInfoBox
                    headline="How to Play"
                    body={gameData.gameObjective}
                    extraClass=" ContentInfoBox--GameObjective"
                  />
                  <GameControls {...gameData} />
                  <PromoBox
                    type="tinybop-schools"
                    logo={
                      <img
                        className="AnnouncementModal__image"
                        src="https://www.funbrain.com/assets/img/sponsors/custom/TinybopSchools201809/TinybopSchools201809_logo.png"
                        alt="Tinybop Schools"
                        style={{ width: 200 }}
                      />
                    }
                  >
                    <p>
                      Tinybop Schools offers engaging science simulations for
                      K-5 classrooms, along with teaching resources to support
                      learning and exploration. Students can explore anatomy,
                      meteorology, engineering, geology, astronomy, and more!
                    </p>
                    <Button
                      externalLink={`${outboundLink}&utm_medium=button&utm_content=promobox`}
                      withAction
                      buttonContext="promo"
                      actionIcon="arrow"
                      text="Sign up for a free trial today!"
                    />
                  </PromoBox>
                  <ContentInfoBox
                    headline="Supplemental Materials & Activities"
                    extraClass=" ContentInfoBox--full ContentInfoBox--transparent"
                  >
                    <MaterialsComponent />
                  </ContentInfoBox>
                </div>
              </div>
              <aside className="ContentBlock__aside">
                {/* Links to Tinybop.com */}
                <StaticAdSlot
                  src="https://www.funbrain.com/assets/img/sponsors/custom/TinybopApps202003/TinybopApps2020-03_300x250@2x.png"
                  link="https://tinybop.com/apps"
                />
                <br />
                <StaticAdSlot
                  src="https://www.funbrain.com/assets/img/sponsors/custom/TinybopSchools201809/TinybopSchools201809_halfpage_300x600.png"
                  link={`${outboundLink}&utm_medium=banner&utm_content=halfpage`}
                />
              </aside>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => {
  return {
    isFetching: reducers.getIsPageFetching(state),
    errors: reducers.getErrors(state),
  };
};

const allActions = {
  ...mediaActions,
  ...listsActions,
  ...adsActions,
};

const SchoolsDemoPageComponent = connect(mapStateToProps, allActions)(SchoolsDemoPage);

export default SchoolsDemoPageComponent;
